import { Box } from '@chakra-ui/react'
import type { DocumentFolder, FolderTreeNode } from '../types'
import type { CoOwnerFolderLink } from '../hooks/useCoOwnerFolders'
import { FolderTree } from './FolderTree'

interface CollapsibleDocumentsSidebarProps {
  residenceId: string
  folders: DocumentFolder[]
  folderTree: FolderTreeNode[]
  currentFolderId: string | null
  coOwnerFolders: CoOwnerFolderLink[]
  onSelectFolder: (folderId: string | null) => void
  onCreateSubfolder: (parentFolderId: string) => void
  onEditFolder: (folderId: string) => void
  onDeleteFolder: (folderId: string) => void
  onDrop: (targetFolderId: string | null) => void
  onDropDocument?: (documentId: string, folderId: string | null) => void
}

export function CollapsibleDocumentsSidebar({
  residenceId,
  folderTree,
  currentFolderId,
  coOwnerFolders,
  onSelectFolder,
  onCreateSubfolder,
  onEditFolder,
  onDeleteFolder,
  onDrop,
  onDropDocument,
}: CollapsibleDocumentsSidebarProps) {
  return (
    <Box
      position="sticky"
      top="20px"
      alignSelf="start"
      maxH="calc(100vh - 100px)"
      borderWidth="1px"
      borderRadius="lg"
      bg="white"
      w="280px"
      overflow="hidden"
      display="flex"
      flexDirection="column"
    >
      {/* Arborescence complète */}
      <Box pt={4} pb={4} px={3} overflowY="auto" flex="1">
        <FolderTree
          residenceId={residenceId}
          tree={folderTree}
          selectedFolderId={currentFolderId ?? undefined}
          coOwnerFolders={coOwnerFolders}
          onSelectFolder={onSelectFolder}
          onCreateSubfolder={onCreateSubfolder}
          onEditFolder={onEditFolder}
          onDeleteFolder={onDeleteFolder}
          onDrop={onDrop}
          onDropDocument={onDropDocument}
        />
      </Box>
    </Box>
  )
}
